import styled from 'styled-components';
import color from '../../../../constants/color';
import materialUI from '../../../../material-UI';

export const ContainerInfoImageBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: 80px;
`;
export const RowCheck = styled.div`
  display: flex;
`;
export const Img: any = styled.img``;
export const Space = styled.div`
  height: 18px;
`;
export const Title = styled.div`
  font-size: 24px;
  color: ${color.Black}
  font-family: Inter;
`;
export const InfoImage = styled.div`
  font-size: 14px;
  color: ${color.Black}
  margin: 18px 0px 18px 0px;
  font-family: Inter;
`;
export const Ping: any = styled.div`
  height: 14px;
  background-color: ${(props: any) => props.style?.backgroundColor};
  width: 14px;
  border-radius: 16px;
  padding: 4px;
  margin-right: 4px;
`;
export const Button = styled(materialUI.Button)`
  border-radius: 18px;
  color: ${color.white};
  height: 32px;
  width: 129px;
  background-color: ${color.primary};
  font-size: 10px;
  font-weight: normal;
`;
